export default function validatePassword(value) {
  let criteria = 0;

  if (/[a-z]/.test(value)) {
    criteria++;
  }
  if (/[A-Z]/.test(value)) {
    criteria++;
  }
  if (/^[a-zA-Z0-9]*$/.test(value) === false) {
    criteria++;
  }
  if (/\d/.test(value) === true) {
    criteria++;
  }
  return criteria;
}
